module.exports = __webpack_public_path__ + "static/media/signOut.d74d8804.svg";